// Intent: the landing for the invite link (…/dolacz?kod=HH-XXX-XXX) shared in
// the "X zaprasza Cię do wspólnego budżetu" message. It only STORES the code
// and routes to the right place — a fresh install goes through onboarding, a
// logged-in user auto-joins after login (auth-store consumes the code), and an
// existing local user finds the code prefilled on the household screen.

import { router, useLocalSearchParams } from 'expo-router';
import { useEffect } from 'react';
import { ActivityIndicator, View } from 'react-native';

import { useAppMetaStore } from '@/store/app-meta-store';
import { useAuthStore } from '@/store/auth-store';
import { colors } from '@/theme/tokens';

export default function JoinLandingScreen() {
  const { kod } = useLocalSearchParams<{ kod?: string }>();
  const metaHydrated = useAppMetaStore((s) => s.hydrated);
  const onboardingDone = useAppMetaStore((s) => s.onboardingDone);
  const setPendingHouseholdCode = useAppMetaStore((s) => s.setPendingHouseholdCode);
  const account = useAuthStore((s) => s.account);

  useEffect(() => {
    if (!metaHydrated) return;
    void (async () => {
      if (typeof kod === 'string' && kod.trim()) await setPendingHouseholdCode(kod);
      if (!onboardingDone) router.replace('/onboarding');
      else if (account) router.replace('/household');
      else router.replace('/auth/login');
    })();
  }, [metaHydrated, onboardingDone, account, kod, setPendingHouseholdCode]);

  return (
    <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: colors.background }}>
      <ActivityIndicator color={colors.primary} />
    </View>
  );
}
